<template>
	<div class="export-popi">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>

		<h1>Export Product Mismatch</h1>

		<p class="description">
			This page will export the shops product quantity mismatch.
		</p>

		<div class="single-text-wrapper">
			<b-field label="Select Shop (Required)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>
		</div>

		<div class="button-container">
			<div class="big-button" @click="exportMismatch()">
				Export Product Mismatch
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'exportReturn',
	data: function() {
		return {
			limit: 100,
			isLoading: false,
			shops: [],
			shopsSuggestions: '',
			selectedShop: null
		}
	},

	watch: {},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		await this.getShops()
	},

	methods: {
		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		// Export products on user click
		exportMismatch: async function() {
			// Make sure fromDate is not empty
			if (!this.selectedShop) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please select a shop'
				})

				return
			}

			this.isLoading = true

			const data = {
				limit: this.limit,
				shop: this.selectedShop._id,
				sort: {
					createdAt: 'desc'
				},
				populate: ['product']
			}

			let mismatches = []

			const result = await this.$api.getShopProductMismatch({ data })

			if (result !== undefined && result.data.total > 0) {
				result.data.list.map(data => {
					mismatches.push(data)
				})

				// Loop more to get full results
				if (result.data.total > this.limit) {
					var totalLoop = Math.ceil(result.data.total / this.limit)

					var i
					var skip

					// Loop all the pagers
					for (i = 1; i < totalLoop; i++) {
						skip = i * this.limit

						data.skip = skip

						const result = await this.$api.getShopProductMismatch({ data })

						if (result) {
							result.data.list.map(data => {
								mismatches.push(data)
							})
						}
					}
				}

				if (mismatches.length > 0) {
					this.generateCSV(mismatches)
				}
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Nothing found!'
				})

				return
			}
		},

		generateCSV: function(mismatches) {
			let export_csv = ''

			export_csv += 'SHOP,BD CODE,BARCODE,CLOUD,SHOP\r\n'

			// Loop data
			mismatches.map(data => {
				let product = data.product

				const toAdd = [this.selectedShop.name, product.bd_code, product.barcode, data.cloud_stock, data.shop_stock]

				let row = toAdd.join(',')

				export_csv += row + '\r\n'
			})

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', this.selectedShop.shop_id + '_Products_Mismatch_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.returnNumber = null
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
